import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPictoMagicLink = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_591_1085)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6.24992 0.833252C6.24992 2.38035 6.8206 3.86408 7.83642 4.95804C8.85225 6.052 10.23 6.66659 11.6666 6.66659C10.23 6.66659 8.85225 7.28117 7.83642 8.37513C6.8206 9.46909 6.24992 10.9528 6.24992 12.4999C6.24992 10.9528 5.67923 9.46909 4.66341 8.37513C3.64759 7.28117 2.26984 6.66659 0.833252 6.66659C2.26984 6.66659 3.64759 6.052 4.66341 4.95804C5.67923 3.86408 6.24992 2.38035 6.24992 0.833252Z",
				stroke: "#0071CC",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.1667 7.5C14.1667 8.82608 14.6935 10.0979 15.6312 11.0355C16.5689 11.9732 17.8407 12.5 19.1667 12.5C17.8407 12.5 16.5689 13.0268 15.6312 13.9645C14.6935 14.9021 14.1667 16.1739 14.1667 17.5C14.1667 16.1739 13.64 14.9021 12.7023 13.9645C11.7646 13.0268 10.4928 12.5 9.16675 12.5C10.4928 12.5 11.7646 11.9732 12.7023 11.0355C13.64 10.0979 14.1667 8.82608 14.1667 7.5Z",
				stroke: "#0071CC",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.6667 2.5C16.6667 3.16304 16.9301 3.79893 17.399 4.26777C17.8678 4.73661 18.5037 5 19.1667 5C18.5037 5 17.8678 5.26339 17.399 5.73223C16.9301 6.20107 16.6667 6.83696 16.6667 7.5C16.6667 6.83696 16.4034 6.20107 15.9345 5.73223C15.4657 5.26339 14.8298 5 14.1667 5C14.8298 5 15.4657 4.73661 15.9345 4.26777C16.4034 3.79893 16.6667 3.16304 16.6667 2.5Z",
				stroke: "#1E1E1E",
				strokeWidth: .5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.9167 0.833252C12.9167 1.16477 13.0484 1.48271 13.2829 1.71714C13.5173 1.95156 13.8352 2.08325 14.1667 2.08325C13.8352 2.08325 13.5173 2.21495 13.2829 2.44937C13.0484 2.68379 12.9167 3.00173 12.9167 3.33325C12.9167 3.00173 12.7851 2.68379 12.5506 2.44937C12.3162 2.21495 11.9983 2.08325 11.6667 2.08325C11.9983 2.08325 12.3162 1.95156 12.5506 1.71714C12.7851 1.48271 12.9167 1.16477 12.9167 0.833252Z",
				stroke: "#1E1E1E",
				strokeWidth: .5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.5 14.1667C7.5 14.8298 7.76339 15.4657 8.23223 15.9345C8.70107 16.4034 9.33696 16.6667 10 16.6667C9.33696 16.6667 8.70107 16.9301 8.23223 17.399C7.76339 17.8678 7.5 18.5037 7.5 19.1667C7.5 18.5037 7.23661 17.8678 6.76777 17.399C6.29893 16.9301 5.66304 16.6667 5 16.6667C5.66304 16.6667 6.29893 16.4034 6.76777 15.9345C7.23661 15.4657 7.5 14.8298 7.5 14.1667Z",
				stroke: "#1E1E1E",
				strokeWidth: .5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_591_1085",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgPictoMagicLink;
